module.exports = __webpack_public_path__ + "img/logo.389beaf4.png";